export default {
  /**
   * Emits a message to the parent window to indicate that the results have
   * changed. Message will include the height of the container after results
   * are rendered.
   */
  onResultsChanged: () => {
    setTimeout(()=>{
      const resultsContainer = document.querySelector<HTMLElement>(
        '#agent-results-container'
      )
      emitMessage('results_changed', {
        results_container_height: resultsContainer.clientHeight
      })
    }, 1000)
  }
}

const emitMessage = (event: string, data: Record<string, unknown>) => {
  console.log('Emitting message to parent window', {
    source: 'BAM',
    event,
    data
  })
  window.parent.postMessage({ source: 'BAM', event, data }, '*')
}
